import { makeStyles } from "@material-ui/core";

export const addBalanceModalStyle = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:focus-visible": {
      outline: "none",
    },
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: "1px solid #000",
    boxShadow: theme.shadows[5],
    borderRadius: theme.spacing(0.5),
    width: 450,
    // height: "98vh",
    "&:focus-visible": {
      outline: "none",
    },
  },
  modalHeader: {
    Color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
  },
  modalBody: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "24px 16px",
    "& .MuiSelect-select.Mui-disabled": {
      cursor: "not-allowed !important",
      backgroundColor: "#e5e5e5 !important",
    },

    "& .cardSection": {
        display: "flex",
        flexDirection: "column",
        gap: 16,
        maxHeight: '550px',
        overflow: 'auto',
      
      "& .eachCard": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: "1px solid rgba(148, 157, 178, 0.24)",
        borderRadius: 8,
        padding: 16,


        "& .leftSide": {        
          display: "flex",
          alignItems: "flex-start",
          gap: 24,
        },
        "& .rightSide": {
          "& .moreIcon": {
            "&:hover, &:focus": {
              backgroundColor: "transparent",
            }
          }
        },

        "& .cardLogo":{
          "& .logo":{
            // height: 40,
            // padding: 16,
            // backgroundColor: "#f0f0f0",
            // borderRadius: 8,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            '& .MuiSvgIcon-root': {
              fill: 'rgb(62, 80, 247)',
              fontSize: '30px'
            }
          }
        },
        "& .cardDetails":{
          "& .cardNumber":{},
          "& .cardExpireDate":{
            color: "#4c535d",
            fontSize: 14,
            fontWeight: 300
          }
        },
        "& .cardStatus":{
          color: "#366AED",
          fontSize: 12,
          padding: "4px 16px",
          backgroundColor: "#F0F6FF",
          borderRadius: 50,
        }
      },


    }
  },
  modalFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "16px",
    borderTop: "1px solid rgba(148, 157, 178, 0.24)",
    gap: "16px",
    "& .submitButton": {
      "&:hover, &:focus": {
        backgroundColor: "#3f51b5",
      },
    },
  },

  button: {
    padding: "8px 10px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    textTransform: "capitalize",
    fontWeight: 600,
    fontSize: "13px",
  },

  closeButton: {
    backgroundColor: "#ffffff",
    border: "2px solid #d9dce0",
    color: "#333",
    "&:focus, &:hover": {
      backgroundColor: "#f6f6f6",
    },
  },

  confirmButton: {
    backgroundColor: "#3e50f7",
    color: "#fff",
    border: "2px solid #3e50f7",
    "&:focus, &:hover": {
      border: "2px solid #3e50f7",
      backgroundColor: "#3e50f7",
    },
    "&:disabled": {
      backgroundColor: "rgba(62,80,247,0.46)",
      border: "2px solid transparent",
      cursor: 'default'
    },
  },

  disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    pointerEvents: "none",
  },
  errorMessage: {
    color: "#dc6464",
    fontSize: "12px",
    marginLeft: "6px"
  },
  cardContainer: ({ disabled }) => ({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '15px',
    width: '100%',
    '& .StripeElement': {
      width: '100%',
      border: '1px solid',
      borderRadius: '6px',
      borderColor: 'rgba(0, 0, 0, 0.26)',
      padding: '11.92px 8px',
      flex: 1,
      cursor: disabled ? 'not-allowed !important' : '',
      backgroundColor: disabled ? '#e5e5e5 !important' : ''
    },
    '& label': {
      color: '#000'
    }
  }),
  cardEmailField: {
    width: '100%',
    '& .MuiInputBase-input': {
      fontSize: '0.85rem',
      color: '#333',
      padding: `${theme.spacing(1)}px !important`,
      border: 'none !important',
      margin: '0 !important'
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '6px',
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.26)',
        borderWidth: '1px'
      },
      '&:hover fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.26)',
        borderWidth: '1px'
      },
      '&.Mui-focused fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.26)',
        borderWidth: '1px'
      },
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: '#333',
      WebkitTextFillColor: '#333',
    },
    '& .Mui-focused input': {
      boxShadow: 'none !important'
    },
    flex: 1,
    '& .MuiFormHelperText-root': {
      fontSize: "12px",
      color: "red",
      fontFamily: "var(--poppins)"
    }
  },
  cardZipField: {
    width: '100%',
    '& .MuiInputBase-input': {
      fontSize: '0.85rem',
      color: '#333',
      padding: `${theme.spacing(1)}px !important`,
      border: 'none !important',
      margin: '0 !important'
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '6px',
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.26)',
        borderWidth: '1px'
      },
      '&:hover fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.26)',
        borderWidth: '1px'
      },
      '&.Mui-focused fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.26)',
        borderWidth: '1px'
      },
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: '#333',
      WebkitTextFillColor: '#333',
      cursor: 'not-allowed !important',
      backgroundColor: '#e5e5e5 !important'
    },
    '& .Mui-focused input': {
      boxShadow: 'none !important'
    },
    flex: 1,
    '& .MuiFormHelperText-root': {
      fontSize: "12px",
      color: "red",
      fontFamily: "var(--poppins)"
    }
  },
  stripeErrorMessage: {
    color: "red",
    marginLeft: "10px"
  },
  cardElemFlex: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    gap: "16px",
    "& label": {
      flex: 1
    }
  },
  cardCountrySelect: {
    '& .MuiInputBase-input': {
      padding: "12.6px 9px !important",
      borderColor: "rgba(0, 0, 0, 0.26) !important",
      borderRadius: '6px !important'
    }
  },
  brandIcon: {
    width: "51px",
    height: "38px",
    backgroundImage: `url(${process.env.REACT_APP_CDN_LINK}assets/images/releases/1.0.0/top-card-brand-icons.png)`,
    backgroundPosition: "-202px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "500px"
  }
}));
